const priceFormatter = new Intl.NumberFormat("sk-SK", {
  style: "currency",
  currency: "EUR",
  minimumFractionDigits: 2,
});

const formatPrice = (number: string | undefined): string => {
  return priceFormatter.format(number ? parseFloat(number) : 0.0);
};

const dateFormatter = new Intl.DateTimeFormat("sk-SK", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const timeFormatter = new Intl.DateTimeFormat("sk-SK", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
});

const formatDate = (date: string | undefined): string => {
  return date ? dateFormatter.format(Date.parse(date ?? "")) : "empty";
};

export const inputDate = (date: string | undefined): string => {
  const dt = Date.parse(date ?? "");
  const y = new Intl.DateTimeFormat("en", { year: "numeric" }).format(dt);
  const m = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(dt);
  const d = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(dt);

  return `${y}-${m}-${d}`;
};

export const apiDate = (date: string | undefined): string => {
  const dt = new Date(date ?? "");
  return dt.toISOString();
};

const formatTime = (time: string | undefined): string => {
  return time ? timeFormatter.format(Date.parse(time ?? "")) : "empty";
};

const formatTableTime = (time: string | undefined): string => {
  // @see https://stackoverflow.com/a/50000889
  const localDateTime = new Date(time ?? "");
  return [
    localDateTime.toLocaleDateString("sk-SK", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }),
    localDateTime.toLocaleTimeString("sk-SK", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    }),
  ].join(" ");
};

export const formatOpenHours = (hours: number | undefined) => {
  let hoursStr = String(hours || 0);
  while (hoursStr.length < 4) {
    hoursStr = `0${hoursStr}`;
  }

  return `${hoursStr.slice(0, 2)}:${hoursStr.slice(2, 4)}`;
};

const openHoursToValue = (value: string) => {
  const val = value.replace(":", "").slice(0, 4);
  return Number(val);
};

const formatters = {
  formatPrice,
  formatDate,
  formatTime,
  formatTableTime,
  formatOpenHours,
  openHoursToValue,
  inputDate,
  apiDate,
};

export function useFormatters(): typeof formatters {
  return formatters;
}
